import { render, staticRenderFns } from "./VaultMoveConfirm.vue?vue&type=template&id=7af91c6f&scoped=true&"
import script from "./VaultMoveConfirm.vue?vue&type=script&lang=ts&"
export * from "./VaultMoveConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./VaultMoveConfirm.vue?vue&type=style&index=0&id=7af91c6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af91c6f",
  null
  
)

export default component.exports